import React, { Fragment } from 'react';
import { Alert } from 'reactstrap';
import { useUser } from '../UserAccess/useUser';

type Props = {
  children: React.ReactNode
}

const BusinessTemplate = ({ children }: Props) => {
  const user = useUser();

  if (user.selectedBusiness)
    return <Fragment key={user.selectedBusiness.id}>{children}</Fragment>

  if (user.businesses.length > 0)
    return <Alert color='danger'>Please select a business.</Alert>

  return <Alert color='danger'>
    No businesses found. Please ensure your account login is correct. If the account is correct, please contact your business administrator or Kahler Automation.
  </Alert>
}

export default BusinessTemplate;
